import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "12",
  fill: "none",
  viewBox: "0 0 8 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M-8186.7 15.9h16383M1.2 8.3l2.9-2.9L7 8.3s.1.1.2.1h.6s.2 0 .2-.1c0 0 .1-.1.1-.2v-.6s0-.2-.1-.2L4.7 4s-.1-.1-.2-.1h-.6s-.2 0-.2.1L.2 7.3c-.1.1-.2.3-.2.5s0 .3.2.5c.1.1.3.2.5.2s.3 0 .5-.2"
    }, null, -1)
  ]))]))
}
export default { render: render }